import React from 'react';
import Icon from './Icon';
import styles from './Thumb.module.scss';

// 作品缩略图占位（渐变底 + 主题图标），后续接入真实项目截图
const THEMES = {
    space: {bg: 'linear-gradient(135deg, #1e293b, #4338ca)', icon: 'star', color: '#fde68a'},
    monster: {bg: 'linear-gradient(135deg, #86efac, #22c55e)', icon: 'users', color: '#065f46'},
    sea: {bg: 'linear-gradient(135deg, #7dd3fc, #0284c7)', icon: 'brush', color: '#eff6ff'},
    maze: {bg: 'linear-gradient(135deg, #111827, #374151)', icon: 'puzzle', color: '#4ade80'},
    music: {bg: 'linear-gradient(135deg, #4ade80, #16a34a)', icon: 'bolt', color: '#052e16'}
};

export default function Thumb ({theme = 'space', className = '', ratio = '16 / 10'}) {
    const t = THEMES[theme] || THEMES.space;
    return (
        <div
            className={[styles.thumb, className].filter(Boolean).join(' ')}
            style={{background: t.bg, aspectRatio: ratio}}
            aria-hidden="true"
        >
            <Icon name={t.icon} size={48} style={{color: t.color}} />
        </div>
    );
}
